import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/AppShell.tsx");
;
import(/* webpackMode: "eager" */ "/app/css/tailwind.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Noto_Sans\",\"arguments\":[{\"style\":[\"normal\",\"italic\"],\"subsets\":[\"latin\"],\"display\":\"swap\"}],\"variableName\":\"notoSans\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/pliny/search/algolia.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/remark-github-blockquote-alert/alert.css");
;
import(/* webpackMode: "eager" */ "/app/css/vendors/bootstrap.min.css");
;
import(/* webpackMode: "eager" */ "/app/scss/style.scss");
